/* eslint-disable no-return-assign */
// eslint-disable-next-line import/no-cycle
import axiosIns, { axiosInsNoEnc } from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    email: null,
    username: null,
    userData: null,
    myCompany: {
      company_id: null,
      company_name: '',
      country_id: 1,
      country_name: '',
      province_id: 2,
      province_name: '',
      city_id: '',
      city_name: '',
      rt: '',
      rw: '',
      zip_code: '',
      business_field: '',
      company_type: '',
      company_address: '',
      saldo: '',

    },
    myAccount: {
      citizen_id: null,
      email: '',
      firstname: '',
      lastname: '',
      phone: '',
      // role_id: 3,
      // status: 2,
      username: '',
    },
    role: null,
    role_id: null,
  },
  getters: {
    getEmail: state => state.email,
    getRole: state => state.role,
    getUsername: state => state.username,
    getUserData: state => state.userData,
    getMyCompany: state => state.myCompany,
    getMyAccount: state => state.myAccount,
  },
  mutations: {
    SET_EMAIL: (state, value) => (value ? (state.email = value) : (state.email = null)),
    SET_ROLE: (state, value) => (value ? (state.role = value) : (state.role = null)),
    SET_USERNAME: (state, value) => (value ? (state.username = value) : (state.username = null)),
    SET_USER_DATA: (state, value) => (value ? (state.userData = value) : (state.userData = null)),
    SET_MY_COMPANY: (state, value) => (value ? (state.myCompany = value) : (state.myCompany = {})),
    SET_MY_ACCOUNT: (state, value) => (value ? (state.myAccount = value) : (state.myAccount = {})),
  },
  actions: {
    checkUsername({ commit }, payload) {
      const username = typeof payload.username !== 'undefined' ? payload.username : ''

      return new Promise((resolve, reject) => {
        axiosIns.post('login/checkUsername', {
          username,
        })
          .then(response => {
            commit('SET_EMAIL', response.data.data.email)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    checkPassword({ commit }, payload) {
      const email = typeof payload.email !== 'undefined' ? payload.email : ''
      const password = typeof payload.password !== 'undefined' ? payload.password : ''

      return new Promise((resolve, reject) => {
        axiosIns.post('login', {
          email,
          password,
        })
          .then(response => {
            if (response.data.status !== false) {
              if (response.original.data.account.status !== 1) {
                commit('SET_USER_DATA', response.data)
                commit('SET_MY_COMPANY', response.data.data.company)
                commit('SET_MY_ACCOUNT', response.data.data.Account)
                commit('SET_ROLE', response.data.data.role_id)
              }else  {
                alert("Waiting Approval");
              }
            }
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    registration({}, payload) {
      // const username = typeof payload.username !== 'undefined' ? payload.username : ''

      return new Promise((resolve, reject) => {
        axiosInsNoEnc.post('register',
          payload,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(response => {
            // commit('SET_EMAIL', response.data.data.email)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
}
